import { Text } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form/core'
import { LabelItemInativo } from 'components/LabelItemInativo'
import { PerfilSelectFieldDocument } from 'graphql/hooks.generated'
import { PerfilSelectFieldQuery, PerfilSelectFieldQueryVariables, TipoAcesso } from 'graphql/types.generated'

import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type PerfilSelectModel = PerfilSelectFieldQuery['perfis']['content'][0]

export type PerfilSelectFieldProps = DistributiveOmit<CustomSelectFieldProps<PerfilSelectModel>, 'itemIsEqual'> & {
  tipoAcesso?: TipoAcesso
  mostrarInativos?: boolean
  mostrarQualquerLocalidade?: boolean
}

export function PerfilSelectField(props: PerfilSelectFieldProps) {
  const { tipoAcesso, mostrarInativos, mostrarQualquerLocalidade, ...rest } = props

  const {
    selectProps: { loading, ...asyncProps },
  } = useAsyncQuerySelect<PerfilSelectModel, PerfilSelectFieldQuery, PerfilSelectFieldQueryVariables>({
    query: PerfilSelectFieldDocument,
    extractItems: extractItems,
    variables: (inputQuery: string) => ({
      input: {
        tipoAcesso,
        mostrarInativos,
        mostrarQualquerLocalidade,
        query: inputQuery,
        pageParams: {
          ...DEFAULT_SELECT_PAGE_PARAM,
          sort: ['nome'],
        },
      },
    }),
  })

  return (
    <SelectField<PerfilSelectModel>
      itemIsEqual={itemIsEqual}
      renderItem={renderItem}
      itemToString={itemToString}
      icon={null}
      {...asyncProps}
      {...rest}
    />
  )
}

const itemToString = (op: PerfilSelectModel) => op && (op.ativo ? op.nome : op.nome + ' [Inativo]')

const renderItem = (op: PerfilSelectModel) => (
  <Text>
    {op.nome}
    <LabelItemInativo ativo={op.ativo} />
  </Text>
)

const extractItems = (data: PerfilSelectFieldQuery) => data && data.perfis && data.perfis.content

const itemIsEqual = (a: PerfilSelectModel, b: PerfilSelectModel) => a?.id === b?.id
